import { Link } from "react-router-dom";
import "./Home.css";

export default function Home() {
  return (
    <div className="home">
      <header className="home-hero">
        <div className="home-hero-inner">
          <div className="home-kicker">Lumia · AI construction documents</div>

          <h1 className="home-title">
            Generate RAMS documents
            <span className="home-title-accent"> from rough site notes.</span>
          </h1>

          <p style={{ opacity: 0.85, lineHeight: 1.6, marginTop: 12 }}>
            Create practical, site-ready Risk Assessments and Method Statements in minutes.
          </p>

          <div className="home-actions">
            <Link to="/rams" className="home-btn home-btn-primary">
              Generate RAMS
            </Link>

            <Link to="/risk" className="home-btn home-btn-ghost">
              Risk Assessment
            </Link>

            <Link to="/method" className="home-btn home-btn-ghost">
              Method Statement
            </Link>

            <Link to="/tools" className="home-btn home-btn-ghost">
              View tools
            </Link>
          </div>
        </div>
      </header>

      <main className="home-main">
        <section className="home-grid">
          <article className="home-card">
            <h2>RAMS generator</h2>
            <p>
              Generate a full Risk Assessment and Method Statement in one combined draft.
            </p>
            <Link to="/rams" className="home-link">
              Generate RAMS →
            </Link>
          </article>

          <article className="home-card">
            <h2>Risk Assessment</h2>
            <p>Turn site notes into a structured UK-style risk assessment.</p>
            <Link to="/risk" className="home-link">
              Create risk assessment →
            </Link>
          </article>

          <article className="home-card">
            <h2>Method Statement</h2>
            <p>Create a practical step-by-step method statement for site work.</p>
            <Link to="/method" className="home-link">
              Create method statement →
            </Link>
          </article>

          <article className="home-card">
            <h2>Tools</h2>
            <p>All current document-generation tools in one place.</p>
            <Link to="/tools" className="home-link">
              View tools →
            </Link>
          </article>
        </section>
      </main>
    </div>
  );
}